<template>
  <div class="table-row settings-tender-table-columns">
    <div class="settings-users-table__cell">
      <UserInfo v-if="member" :key="member.id" :user="member" :show-position="false">
        <template v-if="member.is_activated" #after-name>
          <div class="dot" />
          <span v-if="offer.contractor_contact_person_user.id === member.user_id">Responsible</span>
          <ButtonLink
            v-else
            class="set-responsible-link"
            @click="setResponsibleUser(member.user_id)"
          >
            <Spinner v-if="responsibleLoadingUserId === member.user_id" size="20" />
            <span v-else>{{ $t('Set responsible') }}</span>
          </ButtonLink>
        </template>
      </UserInfo>
    </div>
    <div class="settings-users-table__cell vertical-centering">
      <span class="text-sm file-title">{{ member.position }}</span>
    </div>
    <div class="settings-users-table__cell vertical-centering">
      <div v-if="member.role" class="d-contents">
        <div class="flex-row flex-centering spacex-8">
          <Badge :muted="!member.is_activated" color="light-grey" bordered>
            {{ member.is_activated ? roles[member.role] : $t('invited') }}
          </Badge>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import UserInfo from '@/components/ui/UserInfo';
  import Badge from '@/components/ui/Badge';
  import ButtonLink from '@/components/ui/ButtonLink';
  import factory from '@/utils/api/factory';
  import parseError from '@/utils/formatting/parse-error';
  import t from '@/i18n';
  import Spinner from 'vue-simple-spinner';
  import { mapState } from 'vuex';

  export default {
    name: 'TenderMemberRow',
    components: {
      UserInfo,
      Badge,
      ButtonLink,
      Spinner,
    },
    props: {
      member: Object,
      offer: Object,
    },
    data() {
      return {
        responsibleLoadingUserId: null,
      };
    },
    computed: {
      ...mapState('global', ['roles']),
    },
    methods: {
      async setResponsibleUser(userId) {
        this.responsibleLoadingUserId = userId;
        try {
          await factory('incoming_tenders/offers').postInResourcePath(
            this.offer.id,
            'contact_person',
            { id: userId }
          );
          this.$emit('update-members');
        } catch (e) {
          // eslint-disable-next-line no-console
          console.error(e);
          alert(parseError(e) || t('Something wrong happened'));
        }
        this.responsibleLoadingUserId = null;
      },
    },
  };
</script>

<style scoped>
  .dot {
    display: inline-block;
  }
  .dot:before {
    content: '\b7';
    margin: 0 4px;
  }
</style>
